import QRCode from 'qrcode'
import type {
  QRCodeOptions,
  QRCodeService,
} from '@/domain/affiliate/QRCodeService'

export class BrowserQRCodeService implements QRCodeService {
  async toDataURL(text: string, options?: QRCodeOptions): Promise<string> {
    return QRCode.toDataURL(text, options)
  }
}
